import { mountHTTPInstance } from '@ghq-abi/auth-client-lib/client';
import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';

export class ApiBuilder {
  private static instance: ApiBuilder;

  public static getInstance(): ApiBuilder {
    if (!ApiBuilder.instance) {
      ApiBuilder.instance = new ApiBuilder();
    }
    return ApiBuilder.instance;
  }

  /**
   * Create a server-side Axios instance
   * @param config Axios configuration
   * @param token Authentication token (optional)
   * @returns AxiosInstance
   */
  public mount(
    config: AxiosRequestConfig = {},
    token?: string | null
  ): AxiosInstance {
    const api = axios.create({
      ...config,
      withCredentials: true,
    });

    // Attach token if provided
    api.interceptors.request.use(request => {
      if (!token) return request;

      request.headers = request.headers ?? {};
      const hasAuthHeader = !!request.headers.Authorization;

      if (!hasAuthHeader) {
        request.headers.Authorization = `Bearer ${token}`;
      }

      return request;
    });

    return api;
  }
}

export const oprApi = mountHTTPInstance({
  baseURL: process.env.NEXT_PUBLIC_OPR_API_URL,
});

export const serverOprApi = (token?: string | null) =>
  ApiBuilder.getInstance().mount(
    {
      baseURL: process.env.NEXT_PUBLIC_OPR_API_URL,
    },
    token
  );

export const translationApi = mountHTTPInstance({
  baseURL: process.env.NEXT_PUBLIC_TRANSLATION_API_URL,
});

export const peoplePlatformApi = mountHTTPInstance({
  baseURL: process.env.NEXT_PUBLIC_PEOPLE_PLATFORM_API_URL,
});

export const photoApi = mountHTTPInstance({
  baseURL: process.env.NEXT_PUBLIC_PEOPLE_PLATFORM_PHOTO_API_URL,
  responseType: 'blob',
});
